export const getTimes = async (serviceUrl: string, layerId: string, instanceId: string) => {
    const response = await fetch(`${serviceUrl}/v1/wxtiles/layer/${layerId}/instance/${instanceId}/times/`);
    return await response.json();
};

export const getLayers = async (serviceUrl: string) => {
    const response = await fetch(`${serviceUrl}/v1/wxtiles/layer/`);
    const layers: _WXTilesLayer[] = await response.json();
    return layers;
};

export const getUrl = (serviceUrl: string, layerId: string, styleId: string, instanceId: string, time: string) => {
    return `${serviceUrl}/v1/wxtiles/tile/${layerId}/${styleId}/${instanceId}/${time}/0/{z}/{x}/{y}.png`;
};

// Start of wxtiles types, todo, probably a better way to do this too
export interface _WXTilesLayer {
    bounds: {
        west: number;
        east: number;
        north: number;
        south: number;
    };
    defaults: {
        style: string;
    };
    dimensions: string[];
    id: string;
    instanceDescription: string;
    instanceType: string;
    instances: Instance[];
    maxNativeZoom: number;
    minNativeZoom: number;
    name: string;
    organisation: string;
    regions: Region[];
    resources: Resource;
    source: string;
    styles: {
        description: string;
        id: string;
        label: string;
        name: string;
        resources: {
            jsonLegend: string;
            legend: string;
        };
    }[];
}

interface Resource {
    tile: string;
    times: string;
}

interface Region {
    m49: string;
    name: string;
}

interface Instance {
    displayName: string;
    end: string;
    id: string;
    start: string;
}
